import _API from "./axios"

export const fetcher = async (url) => {
    const res = await _API.get(url, {  params: {}, headers: null, uniqueRequest: false })
    return res;
}